import Sheet from 'components/Sheet/Sheet'
import SheetContainer from 'components/Sheet/SheetContainer'
import SheetTitle from 'components/Sheet/SheetTitle'
import Head from 'next/head'

import styled from 'styled-components'

const performance = ({  }) => {
  return (<>
    <SheetContainer>
      <Head>
        <title>Performance - SIMM</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <SheetTitle>Today's Performance</SheetTitle>
      <Sheet 
        className="iframe-placeholder"
        height='870' 
        width='1980'
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQvQUQBDggQT4_HXyzT8Zo74JUF8cGkRlHkPmYPxBuM1xa1x42PNg0bn30sqIyuf9dv002HeAzv0Tq-/pubhtml?gid=1683164313&amp;single=true&amp;widget=true&amp;headers=false&amp;chrome=false&amp;rm=minimal"
      />

      <SheetTitle>Transactions</SheetTitle>
      <Sheet 
        className="iframe-placeholder"
        height='860' 
        width='1000'
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQvQUQBDggQT4_HXyzT8Zo74JUF8cGkRlHkPmYPxBuM1xa1x42PNg0bn30sqIyuf9dv002HeAzv0Tq-/pubhtml?gid=374866652&amp;single=true&amp;widget=true&amp;headers=false&amp;chrome=false&amp;rm=minimal"
      />
    </SheetContainer>
  </>)
}

export default performance
